import { Button, Flex, Heading, useDisclosure } from '@chakra-ui/react';
import { useGetOfferScorecardsForAgentQuery } from '@client/graphql/__generated__/main-operations';
import { PlusIcon } from 'lucide-react';
import { useMemo } from 'react';
import { CenterSpinner } from '~/common/components/CenterSpinner';
import { useInfiniteQuery } from '~/services/document/hooks';
import { AddBuyerOfferAnalysisModal } from '../BuyerOfferAnalysis/Modals/AddBuyerOfferAnalysisModal';
import { OfferScorecardsNoData } from './OfferScorecardsNoData';
import { OfferScorecardsTable } from './OfferScorecardsTable';

export const OfferScorecardsForAgent = ({ partyId }: { partyId?: string }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [
    fetchOfferScorecardsTriggerRef,
    { data, loading: offerScorecardsLoading },
  ] = useInfiniteQuery(useGetOfferScorecardsForAgentQuery, {
    variables: {
      filters: partyId
        ? {
            partyUuid: partyId,
          }
        : {},
    },
  });

  const offerScorecards = useMemo(
    () => data?.offerScorecardsForAgent?.results || [],
    [data]
  );

  const noData = !offerScorecards.length && !offerScorecardsLoading;

  return (
    <Flex
      direction="column"
      gap={4}
      height="100%"
      overflow={noData ? 'auto' : 'hidden'}
      width="100%"
    >
      <Flex justifyContent="space-between">
        <Heading size="xxs">Offer Scorecards</Heading>
        <Button leftIcon={<PlusIcon size={16} />} size="xs" onClick={onOpen}>
          New
        </Button>
      </Flex>
      {!offerScorecards.length && offerScorecardsLoading && <CenterSpinner />}
      {noData && <OfferScorecardsNoData onClick={onOpen} />}
      {offerScorecards.length > 0 && (
        <OfferScorecardsTable
          fetchTriggerRef={fetchOfferScorecardsTriggerRef}
          loading={offerScorecardsLoading}
          offerScorecards={offerScorecards}
          showAgent={false}
          showBuyer={!partyId}
        />
      )}
      <AddBuyerOfferAnalysisModal
        isOpen={isOpen}
        partyId={partyId}
        onClose={onClose}
      />
    </Flex>
  );
};
